import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import { APPLICATIONS, ErasmusServicePath } from "utils/constants";
import { tenants } from "utils/tenants";
import ListOutgoingApplicationsStudents from "./List";
import { outgoingStudentsPermissions } from "./permissions";
import ShowOutgoingApplicationsStudent from "./Show/Show";

export const resources = {
  isMenu: true,
  icon: <CastForEducationIcon />,
  tenancies: [tenants.MU],
  name: `${ErasmusServicePath}${APPLICATIONS}`,
  title: "Заминаващи студенти",
  list: <ListOutgoingApplicationsStudents />,
  show: <ShowOutgoingApplicationsStudent />,
  showPermission: outgoingStudentsPermissions,
  permission: outgoingStudentsPermissions,
};
